













































import Vue from "vue";
import DoughnutChart from "@/components/Chart/DoughnutChart.vue";
import StandartCard from "@/components/Card/StandartCard/StandartCard.vue";
import { store } from "@/store/store";
import { mapState } from "vuex";

interface DeviceInformationsMainStatus {
  name: string;
  color: string;
  count: number;
}

interface DeviceMainStatusCardData {
  device_status: Array<DeviceInformationsMainStatus>;
  data: any;
}

export default Vue.extend({
  name: "DeviceMainStatusCard",
  components: { DoughnutChart, StandartCard },
  data(): DeviceMainStatusCardData {
    return {
      device_status: [],
      data: {}
    };
  },
  mounted(): void {
    this.countDeviceStatus();
    this.dataCollection();
  },
  methods: {
    countDeviceStatus(): void {
      store.getters.DEVICE_ALL_ID.forEach((device_id) => {
        let device_state: string = store.getters.DEVICE_BY_ID[device_id].state;
        let main_state_id: string = store.getters.STATE_BY_ID[device_state].main_state;
        let main_state_name: string = store.getters.MAIN_STATE_BY_ID[main_state_id].name;
        let device_status = this.device_status.find((status) => status.name === main_state_name);
        if (device_status) device_status.count += 1;
        else
          this.device_status.push({
            name: main_state_name,
            count: 1,
            color: store.getters.MAIN_STATE_BY_ID[main_state_id].color
          });
      });
    },
    dataCollection(): any {
      this.data = {
        fontColor: "#ffffff",
        labels: this.device_status.map((device) => device.name),
        datasets: [
          {
            label: "STATUT DES APPAREILS",
            data: this.device_status.map((device) => device.count),
            backgroundColor: this.device_status.map((device) => device.color)
          }
        ]
      };
    }
  },
  computed: mapState({
    view(): string | null {
      return this.$store.state.view;
    }
  }),
  watch: {
    view: {
      handler(): void {
        this.device_status = [];
        this.countDeviceStatus();
        this.dataCollection();
      }
    }
  }
});
